import { useState } from "react";
import { navLinks } from "@/mocks/blackmole";

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 border-b border-background-200/70 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex w-full max-w-[1240px] items-center justify-between gap-6 px-4 py-3.5 md:px-6">
        <h1 className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
            暴走<span className="text-primary-600">黑料</span>
          </span>
        </h1>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#access"
            className="hidden items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-3.5 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:flex"
          >
            <i className="ri-send-plane-fill text-sm"></i>
            抢先进站
          </a>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-100 text-foreground-800 md:hidden"
          >
            <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-secondary-100"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}